import { Box, Stack, styled, Typography } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
  gap: theme.spacing(4),
  padding: theme.spacing(3),
}));

export const StyledTypographyBase = styled(Typography)({
  textAlign: 'center',
  fontSize: '30px',
  fontWeight: 600,
});

export const StyledTypography = (
  props: ComponentProps<typeof StyledTypographyBase>
) => <StyledTypographyBase variant="h2" {...props} />;

export const StyledLogoContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: theme.spacing(4),
}));

export const StyledLogo = styled('img')(({ theme }) => ({
  width: 'auto',
  height: theme.spacing(3.5),
}));
